import React from 'react';
import PasoSeccion from './PasoSeccion';
import { cn } from '../../lib/utils';

/**
 * Un paso de la reserva, que aparece cuando llega su turno.
 *
 * Los pasos de la página pública no están todos puestos desde el principio:
 * aparecen a medida que se completa el anterior —servicio, profesional, lugar,
 * día y hora—, porque cuáles hacen falta depende del servicio que se elija.
 * Cuando aparece uno, la página además se mueve sola hasta él.
 *
 *
 * EL PASO APARECE DE UNA, SIN ANIMACIÓN
 *
 * Entraba con un fundido y un desplazamiento de 0,45s (framer). Se veía peor
 * de lo que suena: elegir el servicio dispara el fundido de entrada del paso
 * siguiente Y el scroll hacia él al mismo tiempo, así que el bloque aparecía,
 * se movía y encima se corría la pantalla debajo — el efecto era el de algo que
 * carga, desaparece y vuelve a cargar. En un formulario, la respuesta a un
 * click tiene que ser instantánea: lo que la persona necesita es ver la opción
 * que acaba de habilitar, no mirarla llegar.
 *
 * Antes de esto la sección animaba `height: 0 → auto`, y eso además rompía el
 * scroll: para animar un alto `auto`, framer mide, y para medir **scrollea la
 * ventana a 0** y la devuelve (`measureAllKeyframes`), justo en el cuadro en el
 * que arrancaba el scroll hacia el paso. Quedó registrado en una corrida:
 *
 *   1810ms  window.scrollTo [0,0]   <- measureAllKeyframes (framer)
 *   1812ms  lenis.scrollTo 451      -> cero eventos de scroll, scrollY final 0
 *
 * Sin animación no hay ninguna medición ni nada compitiendo con el scroll, y el
 * alto de la sección es el definitivo desde el primer cuadro: la cuenta para
 * centrarla da bien y el calendario no queda cortado mientras se abre.
 *
 * Los `AnimatePresence` que envuelven a estos pasos en BusinessPage quedan sin
 * nada que animar y sacan el paso al instante, que es lo buscado. En el panel
 * PasoPlegable sí anima, porque ahí no hay ningún scroll automático corriendo
 * al mismo tiempo ni un click esperando respuesta.
 */
export default function PasoDeReserva({
  id,
  numero,
  titulo,
  descripcion,
  className,
  contenidoClassName = 'mx-auto max-w-5xl px-4 py-10 sm:px-6 sm:py-14',
  children,
}) {
  return (
    <section
      id={id}
      // `scroll-mt-20` es el margen que respeta la barra fija cuando el scroll
      // lo hace el navegador (`scrollIntoView`): sin esto el título del paso
      // queda tapado justo cuando es lo único que hay que leer.
      className={cn('scroll-mt-20', className)}
    >
      <div className={contenidoClassName}>
        <PasoSeccion numero={numero} titulo={titulo} descripcion={descripcion} />
        {children}
      </div>
    </section>
  );
}
